import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Dashboard from "../pages/Auth/Dashboard";
import ProfileSetting from "../pages/Auth/ProfileSetting";
import SenderId from "../pages/Auth/SenderId";
import Roles from "../pages/Auth/Roles";
import AddRole from "../pages/Auth/AddRole";
import EditRole from "../pages/Auth/EditRole";
import Admins from "../pages/Auth/Admins";
import AddAdmin from "../pages/Auth/AddAdmin";
import EditAdmin from "../pages/Auth/EditAdmin";
import Users from "../pages/Auth/Users";
import SubscriptionPlans from "../pages/Auth/SubscriptionPlans";
import QuickMessageReport from "../pages/Auth/QuickMessageReport";
import BulkMessageReport from "../pages/Auth/BulkMessageReport";
import UserSubscriptions from "../pages/Auth/UserSubscriptions";
import PaymentHistory from "../components/subscriptions/PaymentHistory";
import PostPaidRequests from "../pages/Auth/PostPaidRequests";
import CreatePostPaidRequest from "../pages/Auth/CreatePostPaidRequest";
import EditPostPaidRequest from "../pages/Auth/EditPostPaidRequest";
import PermissionGuard from "../components/permissions/PermissionGuard";
import {
  canAccessPostPaidModule,
  canCreatePostPaidRequest,
  canEditPostPaidRequest,
} from "../utils/permissions";

const AuthRoute = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/profile-setting" element={<ProfileSetting />} />

      <Route
        path="/sender-ids"
        element={
          <SenderId />
        }
      />
      <Route
        path="/quick-message-report"
        element={<QuickMessageReport />}
      />
      <Route
        path="/bulk-messages"
        element={<BulkMessageReport />}
      />
      <Route
        path="/subscriptions"
        element={<SubscriptionPlans />}
      />
      <Route
        path="/user-subscriptions"
        element={<UserSubscriptions />}
      />
      <Route
        path="/admins"
        element={
          <Admins />
        }
      />
      <Route
        path="/admins/add"
        element={
          <AddAdmin />
        }
      />
      <Route
        path="/admins/edit/:adminSlug"
        element={
          <EditAdmin />
        }
      />
      <Route
        path="/clients"
        element={
          <div className="p-8 text-center">
            <h1 className="text-2xl font-bold">Clients</h1>
            <p className="text-gray-600">This page is under development</p>
          </div>
        }
      />
      <Route
        path="/users"
        element={<Users />}
      />
      <Route
        path="/inactive-users"
        element={<Navigate to="/users?status=inactive" replace />}
      />
        <Route
          path="/roles/edit/:roleSlug"
          element={<EditRole />}
        />
      <Route
        path="/roles"
        element={<Roles />}
      />
      <Route
        path="/roles/add"
        element={<AddRole />}
      />
      <Route
        path="/payment-history"
        element={<PaymentHistory />}
      />
      
      <Route
        path="/postpaid-requests"
        element={
          <PermissionGuard
            checkPermission={canAccessPostPaidModule}
            title="Access Denied - Post-Paid Requests"
            message="You don't have permission to access the Post-Paid Requests module. You need at least one of the following permissions: View_Request, Create_Request, Edit_Request, HOD_Approval, or Finance_Approval."
          >
            <PostPaidRequests />
          </PermissionGuard>
        }
      />
      <Route
        path="/postpaid-requests/create"
        element={
          <PermissionGuard
            checkPermission={canCreatePostPaidRequest}
            title="Access Denied - Create Request"
            message="You don't have permission to create post-paid requests. You need the 'Create_Request' permission."
          >
            <CreatePostPaidRequest />
          </PermissionGuard>
        }
      />
      <Route
        path="/postpaid-requests/edit/:requestId"
        element={
          <PermissionGuard
            checkPermission={canEditPostPaidRequest}
            title="Access Denied - Edit Request"
            message="You don't have permission to edit post-paid requests. You need the 'Edit_Request' permission."
          >
            <EditPostPaidRequest />
          </PermissionGuard>
        }
      />

      {/* Catch all route */}
      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
};

export default AuthRoute;
